import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import FormStepWrapper from 'components/form/FormStepWrapper';
import ImageBrowser from 'components/image/ImageBrowser';
import TextInputField from 'components/inputs/TextInputField';
import { useAddCampaign } from 'features/add-campaign/context/AddCampaignProvider';

const VideoUrlInput = styled(TextInputField)`
  margin-top: 14px;
`;

export const AddPhotosStepContent = () => {
  const { t } = useTranslation('addCampaign');
  const { formData, setFieldValue, errors, addPhoto, deletePhoto, movePhoto, maxPhotosCount } = useAddCampaign();
  return (
    <>
      <ImageBrowser
        images={formData.photos}
        onAddPhoto={addPhoto}
        onDeletePhoto={deletePhoto}
        onMovePhoto={movePhoto}
        maxPhotosCount={maxPhotosCount}
      />
      <VideoUrlInput
        value={formData.videoUrl || ''}
        onChange={value => setFieldValue('videoUrl', value)}
        placeholder={t('add-photos.video-url-placeholder')}
        errorMessage={errors.videoUrl}
        testId={'add-campaign-video-url-input'}
      />
    </>
  );
};

const AddPhotos = () => {
  const { t } = useTranslation('addCampaign');
  const { errors } = useAddCampaign();

  return (
    <FormStepWrapper
      header={t('add-photos.header')}
      description={t('add-photos.description')}
      isValid={!errors.photos && !errors.videoUrl}>
      <AddPhotosStepContent />
    </FormStepWrapper>
  );
};

export default AddPhotos;
